<script setup lang="ts">
/**
 * Shows the seller's "complete your owner details" prompt on a request — only
 * when the server says they may complete it here (their verified Emirates ID
 * matches an owner on the request, the owner has not submitted, and an invite is
 * live). Co-owners are never offered this; they onboard through their own links.
 */
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import SellerOwnerOnboardingBanner from '../components/SellerOwnerOnboardingBanner.vue'
import { useSellerOwnerOnboardingAvailabilityQuery } from '../api/queries/useSellerOwnerOnboardingAvailabilityQuery'

const props = defineProps<{
  listingRequestId: string
  /** Whether the request is at owner onboarding — skips the read otherwise. */
  isOwnerOnboardingStage: boolean
}>()

const router = useRouter()
const availabilityQuery = useSellerOwnerOnboardingAvailabilityQuery(
  () => props.listingRequestId,
  () => props.isOwnerOnboardingStage,
)
const isAvailable = computed(() => availabilityQuery.data.value?.isAvailable === true)

function handleStart() {
  void router.push({ name: 'LISTING_OWNER_ONBOARDING', params: { id: props.listingRequestId } })
}
</script>

<template>
  <SellerOwnerOnboardingBanner
    v-if="props.isOwnerOnboardingStage && isAvailable"
    @start="handleStart"
  />
</template>
